export default __webpack_public_path__ + "static/media/svinekam-uden-svær.384619bb.jpg";